import { forwardRef, type InputHTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

/**
 * Input — текстовое поле (`input` макета). Состояния hover/focus/disabled/invalid;
 * цвета/границы/фокус-кольцо из токенов. invalid использует статусный цвет ошибки (red).
 */
export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, invalid, 'aria-invalid': ariaInvalid, ...props }, ref) => (
    <input
      ref={ref}
      aria-invalid={ariaInvalid ?? invalid}
      className={cn(
        'w-full rounded-8 border bg-white px-3 py-2 text-14 text-txt outline-none transition-colors',
        'placeholder:text-txt-tertiary',
        'hover:border-line-strong focus-visible:ring-2 focus-visible:ring-accent',
        'disabled:cursor-not-allowed disabled:bg-subtle disabled:opacity-50',
        invalid ? 'border-red focus-visible:ring-red' : 'border-line-strong',
        className,
      )}
      {...props}
    />
  ),
)
Input.displayName = 'Input'
